import { loginRes } from '../../Login.res';

export const res = {
  title: {
    is: 'Innskráning með rafrænum skilríkjum',
    en: 'Login with electronic ID',
    pl: 'Logowanie identyfikacją elektroniczną',
  } as const,
  login: {
    ...loginRes.loginButtonText,
  } as const,
  authenticate: {
    ...loginRes.authenticateButtonText,
  } as const,
  kennitala: {
    is: 'Kennitala',
    en: 'Id./Reg. No.',
    pl: 'Numer ewidencyjny',
  } as const,
  validationKennitalaRequired: {
    is: 'Kennitala verður að vera útfyllt',
    en: 'Id./Reg. No. is a required field',
    pl: 'Należy wypełnić pole z numer ewidencyjny',
  } as const,
  validationKennitalaInvalid: {
    is: 'Kennitala er ekki rétt skráð',
    en: 'Id./Reg. No. is incorrect',
    pl: 'Numer ewidencyjny jest niepoprawny',
  } as const,
  validationUnableToUseCorporateKennitala: {
    is: 'Nota þarf kennitölu einstaklings við innskráningu',
    en: 'To log in, use the Id. No. (“kennitala”) of an individual',
    pl: 'Do logowania należy użyć numeru ewid. osoby fizycznej',
  } as const,
  externalAuthTypesLinkLabel: {
    is: 'Nánar um Auðkennisappið',
    en: 'Need the Auðkenni app?',
    pl: 'Potrzebujesz Auðkenni app?',
  } as const,
};
